const focusField = field => {
  if (field) {
    field.focus();
  }
};

export default focusField;
